import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Primary } from "../../config/colors";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import ClearRoundedIcon from "@material-ui/icons/ClearRounded";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: Primary.light,
    color: Primary.dark,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export default function HorecaActivityTable({ data }) {
  const classes = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Item</StyledTableCell>
            <StyledTableCell>Company ID</StyledTableCell>
            <StyledTableCell>Company Name</StyledTableCell>
            <StyledTableCell>Candidate ID</StyledTableCell>
            <StyledTableCell>Candidate Name</StyledTableCell>
            <StyledTableCell>Created By</StyledTableCell>
            <StyledTableCell>Created At</StyledTableCell>
            <StyledTableCell>Sent for Interview</StyledTableCell>
            <StyledTableCell>Recruited</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.id}</TableCell>
              <TableCell>{row.company_id}</TableCell>
              <TableCell>{row.company_name}</TableCell>
              <TableCell>{row.event_candidate_id}</TableCell>
              <TableCell>{row.candidate_name}</TableCell>
              <TableCell>{row.display_name}</TableCell>
              <TableCell>
                {row.event_date
                  ? new Date(row.event_date).toLocaleDateString()
                  : ""}
              </TableCell>
              <TableCell>
                <Typography align="center">
                  {row.event_key === "companySendToInterview" ? (
                    <CheckRoundedIcon />
                  ) : (
                    <ClearRoundedIcon />
                  )}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography align="center">
                  {row.event_key === "companyRecruitmentSucceeded" ? (
                    <CheckRoundedIcon />
                  ) : (
                    <ClearRoundedIcon />
                  )}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
          {data.length === 0 ? (
            <TableRow>
              <TableCell>No data found for this period</TableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
